import Yhteystiedot from "../components/Yhteystiedot";

function YhteystiedotPage(){
    return <div>
        <Yhteystiedot/>
    </div>
}

export default YhteystiedotPage;